import React from 'react'
import classes from "./SubscriptionExpiredBanner.module.css";
import { CheveronLeft } from '../../assets/constant';
const SubscriptionExpiredBanner = () => {
    return (
        <div className={classes.wrapper}>
            <div className={classes.infoWrapper}>

                <span className={classes.ball} />
                <p className={classes.information}>Subscription will expire in 3 days</p>
            </div>

            <div className={classes.actionWrapper}>
                <span className={classes.subscribe}>
                    Subscribe
                </span>
                <CheveronLeft />
            </div>
        </div>
    )
}

export default SubscriptionExpiredBanner





// import React from 'react'

// const SubscriptionExpired = () => {
//   return (
//     <div>SubscriptionExpired</div>
//   )
// }

// export default SubscriptionExpired